<template>
  <div class="noteHolder">
    <div class="noteDisplay" v-if="showEventDetails && eventDisplay !== false">
      <div class="noteTop">
        <h1>{{eventDisplay.eventName}}</h1>
        <p class="noteInfo" v-if="eventDisplay.scheduleDetails.unix_start_time !== undefined">
          <span>{{moment.unix(eventDisplay.scheduleDetails.unix_start_time).format('MMMM Do YYYY')}}&nbsp;at&nbsp;{{eventDisplay.scheduleDetails.startTime}} - {{eventDisplay.scheduleDetails.endTime}}</span>
        </p>
        <p class="noteInfo" v-if="eventDisplay.eventDescription !== ' '">
          <span>{{eventDisplay.eventDescription}}</span>
        </p>
      </div>
      <div class="attendaceHolder">
        <div class="noteBox" v-for="attendance in attendances" :key="attendance.personID">
          <h2>{{attendance.firstName}}&nbsp;{{attendance.lastName}}</h2>
          <p class="attendanceEmail">{{attendance.email}}</p>

          <input type="checkbox" v-model="attendance.attended" v-bind:id="attendance.personID" />
        </div>
      </div>
      <div class="confirmBtnHolder">
        <button v-on:click="confirmAttendance">Confirm attendance</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "EventAttendanceDisplay",
  methods: {
    ...mapActions(["updateAttendances"]),
    ...mapMutations(["setEventDisplay"]),
    confirmAttendance() {
        this.updateAttendances({
            classCalendarScheduleReferenceID: this.eventDisplay.scheduleDetails.classCalendarScheduleReferenceID,
            classSessionID: this.eventDisplay.classSessionID
        });
    },
  },
  computed: mapGetters([
    "eventDisplay",
    "showMeetingDetails",
    "showEventDetails",
    "attendances",
  ])
};
</script>

<style lang="scss" scoped src="@/styles/style-noteDisplay.scss">
</style>
